var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favoriteToggle",on:{"click":_vm.toggle}},[_c('i',{class:{'fas': _vm.isActive, 'far': !_vm.isActive, 'fa-star':true}})])}
var staticRenderFns = []

export { render, staticRenderFns }